import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {User} from "./user";
import * as fromStore from "../store";
import {Store} from '@ngrx/store';
import {filter, first, switchMap} from 'rxjs/operators';
import {RouteData} from "../shared/services/route-data/route-data";


@Injectable()
export class UserHostingServicesGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUser)),
          first()
        )
        .subscribe((data: any) => {
          const user: User = data;
          const routeData: RouteData = new RouteData(next.data);
          const manageAllDomains: boolean = (routeData.data.pageId === "hosting-domains-manage-all" && user.hosting_services === null);

          if (manageAllDomains) {
            this._router.navigate(['/websites']);
            resolve(false);
            return;
          }
          resolve(true);
        });
    });
  }

}
